module.exports = __webpack_public_path__ + "static/media/somos_enjoy.5d62fdde.png";